// Real-time stat calculations used during stats entry.
export const pct = (m, a) => (a > 0 ? Math.round((m / a) * 1000) / 10 : 0);

export function computeRow(row) {
  const fg2m = +row.fg2_made || 0;
  const fg2a = +row.fg2_att || 0;
  const fg3m = +row.fg3_made || 0;
  const fg3a = +row.fg3_att || 0;
  const ftm = +row.ft_made || 0;
  const fta = +row.ft_att || 0;
  const tfgm = fg2m + fg3m;
  const tfga = fg2a + fg3a;
  return {
    fg2_pct: pct(fg2m, fg2a),
    fg3_pct: pct(fg3m, fg3a),
    tfgm,
    tfga,
    tfg_pct: pct(tfgm, tfga),
    ft_pct: pct(ftm, fta),
    points: 2 * fg2m + 3 * fg3m + ftm,
  };
}

export function trend(now, prior) {
  if (prior === null || prior === undefined) return "flat";
  if (now > prior + 0.5) return "up";
  if (now < prior - 0.5) return "down";
  return "flat";
}
